import React, { Fragment } from 'react';

export default class ItemsFilter extends React.PureComponent{

    constructor(props){
        super(props)
        this.state = {
            filteredItems: this.filterItems()
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.items !== this.props.items || prevProps.condition !== this.props.condition){
            this.setState({
                filteredItems: this.filterItems()
            });
        }
    }

    filterItems = () => {
        const { items } = this.props;
        if(items){
            return items.filter(item => this.props.condition(item));
        }
        return items;
    }

    render(){
        return(
            this.props.children(this.state.filteredItems)
        );
    }
}
